import { useSyncExternalStore } from 'react';
import type { ModalType } from '../types/ModalType';
import { modalStore } from '../lib/modalStore';

export default () => {
  const activeModal = useSyncExternalStore(modalStore.subscribe, modalStore.getActiveModal, modalStore.getActiveModal);

  return {
    activeModal,
    /**
     * @description Turn on a modal by passing a valid ModalType
     * @param modal of type ModalType or null.
     * @returns void
     */
    setActiveModal: (modal: ModalType | null) => {
      modalStore.setActiveModal(modal);
    },
    /**
     *
     * @description turns off any active modals.
     * @returns void
     */
    clearModal: () => modalStore.setActiveModal(null),
  };
};
